import { trackEvent } from "@tm/insurance/analytics/xdm";
import { usePlanType } from "@tm/ui";
import { useCallback } from "react";
import LandingFaq from "../../../../../components/LandingFaq/LandingFaq";
import { trackListingOmniture } from "../../trackingUtils";
import { IFaqProps } from "./types";

const revampFaqUiConfig = {
  section: {
    $shadow: "0px 10px 30px rgba(175, 175, 175, 0.10)",
  },
  title: {
    $fontSize: "32px",
    $fontWeight: 900,
    $lineHeight: "normal",
    $marginBottom: "16px",
  },
  item: {
    $itemPadding: "24px 24px 16px 16px",
  },
  question: {
    $questionFontSize: "22px",
    $questionFontWeight: 900,
    $questionLineHeight: "normal",
  },
};

const Faq = ({ title, icon, faqList }: IFaqProps) => {
  const { type } = usePlanType();

  const handleTrackEvent = useCallback(
    (actionType: string, eventType: string) => {
      trackListingOmniture({ actionType }, eventType, type);
      trackEvent({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: actionType,
        },
      });
    },
    [type]
  );

  if (!faqList || faqList.length === 0) return null;

  return (
    <LandingFaq
      customTitle={title}
      icon={icon}
      faq={faqList}
      isCommonLanding
      uiConfig={revampFaqUiConfig}
      onTrackEvent={handleTrackEvent}
    />
  );
};

export default Faq;
